export default function canRequestLeadsStatus(request) {
  return request !== 'loading' && request !== 'succeeded';
}
